import Phaser from 'phaser';
import $ from 'jquery';
import { CST } from '../../CST';

var question_index = 0;
var questions;
var current_question;
var answerChecked = 'Not answered';
var agree2 = false;
var agree = false;
var idk = false;
var disagree = false;
var disagree2 = false;

export default class Sus extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.SUS);
	}

	preload() {
		loadQuestionsFromDatabase();
	}

	create(data) {
		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});

		var styleBoldTop = {
			fontFamily: 'Calibri',
			fontSize: 50,
			fontStyle: 'bold',
			color: '#000000',
		};

		var styleTop = {
			fontFamily: 'Calibri',
			fontSize: 35,
			color: '#FFFFFF',
		};

		var styleQuestionNum = {
			fontFamily: 'Calibri',
			fontSize: 60,
			fontStyle: 'bold',
			color: '#FFB400',
		};

		var styleQuestion = {
			fontFamily: 'Calibri',
			fontSize: 40,
			color: '#000000',
		};

		var styleConclusion = {
			fontFamily: 'Calibri',
			fontSize: 40,
			fontStyle: 'bold',
			color: '#FFFFFF',
		};

		this.count = 0;
		this.bg = this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'questionnaire-bg',
		);
		this.popUp = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'questionnaire-popUp-2')
			.setScale(0.78);
		this.popUp2 = this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'sus-pop-up',
		);
		this.next = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 300, 'next-btn')
			.setDepth(1.5)
			.setScale(0.5)
			.disableInteractive();
		setTimeout(() => {
			this.next
				.setInteractive({
					useHandCursor: true,
				})
				.on('pointerdown', () => {
					this.count++;
					this.clickSound.play();
					switch (this.count) {
						case 1:
							this.popUp2.destroy();
							this.question_text = this.add
								.text(
									this.cameras.main.width / 2 - 400,
									this.cameras.main.height / 2 - 275,
									current_question.question,
									styleQuestion,
								)
								.setWordWrapWidth(700, true);
							this.scale = this.add.image(
								this.cameras.main.width / 2 - 20,
								this.cameras.main.height / 2 + 100,
								'scale',
							);
							this.checkBoxAgree2 = this.add
								.sprite(
									this.cameras.main.width / 2 - 370,
									this.cameras.main.height / 2,
									'checkbox-sprite',
								)
								.setFrame(0)
								.setScale(0.7)
								.setInteractive({
									useHandCursor: true,
								})
								.on('pointerdown', () => {
									this.clickSound.play();
									if (agree2 === false) {
										agree2 = true;
										agree = false;
										idk = false;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(1);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									} else {
										agree2 = false;
										agree = false;
										idk = false;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									}
								});
							this.checkBoxAgree = this.add
								.sprite(
									this.cameras.main.width / 2 - 200,
									this.cameras.main.height / 2,
									'checkbox-sprite',
								)
								.setFrame(0)
								.setScale(0.7)
								.setInteractive({
									useHandCursor: true,
								})
								.on('pointerdown', () => {
									this.clickSound.play();
									if (agree === false) {
										agree2 = false;
										agree = true;
										idk = false;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(1);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									} else {
										agree2 = false;
										agree = false;
										idk = false;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									}
								});
							this.checkBoxIDK = this.add
								.sprite(
									this.cameras.main.width / 2 - 15,
									this.cameras.main.height / 2,
									'checkbox-sprite',
								)
								.setFrame(0)
								.setScale(0.7)
								.setInteractive({
									useHandCursor: true,
								})
								.on('pointerdown', () => {
									this.clickSound.play();
									if (idk === false) {
										agree2 = false;
										agree = false;
										idk = true;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(1);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									} else {
										agree2 = false;
										agree = false;
										idk = false;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									}
								});
							this.checkBoxDisagree = this.add
								.sprite(
									this.cameras.main.width / 2 + 165,
									this.cameras.main.height / 2,
									'checkbox-sprite',
								)
								.setFrame(0)
								.setScale(0.7)
								.setInteractive({
									useHandCursor: true,
								})
								.on('pointerdown', () => {
									this.clickSound.play();
									if (disagree === false) {
										agree2 = false;
										agree = false;
										idk = false;
										disagree = true;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(1);
										this.checkBoxDisagree2.setFrame(0);
									} else {
										agree2 = false;
										agree = false;
										idk = false;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									}
								});
							this.checkBoxDisagree2 = this.add
								.sprite(
									this.cameras.main.width / 2 + 340,
									this.cameras.main.height / 2,
									'checkbox-sprite',
								)
								.setFrame(0)
								.setScale(0.7)
								.setInteractive({
									useHandCursor: true,
								})
								.on('pointerdown', () => {
									this.clickSound.play();
									if (disagree2 === false) {
										agree2 = false;
										agree = false;
										idk = false;
										disagree = false;
										disagree2 = true;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(1);
									} else {
										agree2 = false;
										agree = false;
										idk = false;
										disagree = false;
										disagree2 = false;
										this.checkBoxAgree2.setFrame(0);
										this.checkBoxAgree.setFrame(0);
										this.checkBoxIDK.setFrame(0);
										this.checkBoxDisagree.setFrame(0);
										this.checkBoxDisagree2.setFrame(0);
									}
								});
							break;
						case 2:
							stepForward(this, data);
							break;
						case 3:
							stepForward(this, data);
							break;
						case 4:
							stepForward(this, data);
							break;
						case 5:
							stepForward(this, data);
							break;
						case 6:
							stepForward(this, data);
							break;
						case 7:
							stepForward(this, data);
							break;
						case 8:
							stepForward(this, data);
							break;
						case 9:
							stepForward(this, data);
							break;
						case 10:
							stepForward(this, data);
							break;
						case 12:
							pushQuestion(data);
							this.scene.start(CST.SCENES.END, {
								User_ID: data.User_ID,
							});
							break;
					}
				});
		}, 2000);
	}
}

function loadQuestionsFromDatabase() {
	$.ajax({
		async: true,
		type: 'get',
		url: 'api/get-sus-to-json.php', // local
		// url: 'website/get-sus-to-json.php', // live
		dataType: 'JSON',
		success(data) {
			questions = data;
			current_question = nextQuestion();
		},
	}).responseJSON;
}

function stepForward(self, data) {
	if (agree2 === true) {
		answerChecked = 'Agree a lot';
	} else if (agree === true) {
		answerChecked = 'Agree';
	} else if (idk === true) {
		answerChecked = 'Unsure';
	} else if (disagree === true) {
		answerChecked = 'Disagree';
	} else if (disagree2 === true) {
		answerChecked = 'Disagree a lot';
	}

	var userAnswer = {
		User_ID: data.User_ID,
		question_id: current_question.question_order,
		question: current_question.question,
		answer: answerChecked,
	};

	$.ajax({
		type: 'POST',
		url: 'api/post-sus-to-ddbb.php', // local
		// url: 'website/post-sus-to-ddbb.php', // live
		dataType: 'JSON',
		data: userAnswer,
	}).responseJSON;

	current_question = nextQuestion();
	agree2 = false;
	agree = false;
	idk = false;
	disagree = false;
	disagree2 = false;
	answerChecked = 'Not answered';
	self.checkBoxAgree2.setFrame(0);
	self.checkBoxAgree.setFrame(0);
	self.checkBoxIDK.setFrame(0);
	self.checkBoxDisagree.setFrame(0);
	self.checkBoxDisagree2.setFrame(0);
	self.question_text.text = current_question.question;
}

function pushQuestion(data) {
	if (agree2 === true) {
		answerChecked = 'Agree a lot';
	} else if (agree === true) {
		answerChecked = 'Agree';
	} else if (idk === true) {
		answerChecked = 'Unsure';
	} else if (disagree === true) {
		answerChecked = 'Disagree';
	} else if (disagree2 === true) {
		answerChecked = 'Disagree a lot';
	}

	var userAnswer = {
		User_ID: data.User_ID,
		question_id: current_question.question_order,
		question: current_question.question,
		answer: answerChecked,
	};

	$.ajax({
		type: 'POST',
		url: 'api/post-sus-to-ddbb.php', // local
		// url: 'website/post-sus-to-ddbb.php', // live
		dataType: 'JSON',
		data: userAnswer,
	}).responseJSON;
}

function nextQuestion() {
	if (question_index != questions.length) {
		current_question = questions[question_index];
		question_index++;
		return current_question;
	}
}
